module.exports = __webpack_public_path__ + "img/pr-14.350d0f93.png";